import { useMemo } from "react";

import {
  NestedKey,
  NestedValue,
  ProgressBarVariables,
} from "@intelligems/ig-types";
import { useDispatch, useSelector } from "@src/store";
import { setUserInterfaceVariable } from "@src/store/slices/userInterfaces";
import { getUserInterfaceVariable } from "@src/store/slices/userInterfaces/selectors";
import { UserInterfaceField } from "@src/store/slices/userInterfaces/types";

export function useProgressBarVariable<
  T extends NestedKey<ProgressBarVariables>,
>(interfaceId: string, path: T) {
  const dispatch = useDispatch();
  const value = useSelector(
    getUserInterfaceVariable(interfaceId, path)
  ) as NestedValue<ProgressBarVariables, T>;

  return useMemo(() => {
    const setValue = (value: NestedValue<ProgressBarVariables, T>) => {
      dispatch(
        setUserInterfaceVariable({
          interfaceId,
          path,
          value,
        })
      );
    };
    return [value, setValue] as UserInterfaceField<
      NestedValue<ProgressBarVariables, T>
    >;
  }, [value, interfaceId, path]);
}
